var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.872,
    height: 25.9,
    viewBox: "0 0 13.872 25.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-f",
    "data-name": "Icon awesome-facebook-f",
    d: "M14.572,14.569l.719-4.687h-4.5V6.84a2.344,2.344,0,0,1,2.643-2.532h2.045V.317A24.934,24.934,0,0,0,11.852,0c-3.7,0-6.125,2.245-6.125,6.309V9.881H1.609v4.687H5.727V25.9h5.067V14.569Z",
    transform: "translate(-1.609)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7d88ae48854b2906dc6b61a77c48bc74.svg";
export { ForwardRef as ReactComponent };